module.exports = __webpack_public_path__ + "static/media/mantou_rock_sunset_latombe.7d535971.jpg";